import { createWithEqualityFn } from 'zustand/traditional';
import type { WalkthroughKey } from '@pages/PortalAdmin/FormsV2Admin/Walkthroughs/types';

type UpdateServiceWorker = (reloadPage?: boolean) => Promise<void>;

type ServiceWorkerUpdateStore = {
  activeWalkthroughKey: WalkthroughKey | null;
  isUpdating: boolean;
  needRefresh: boolean;
  updateServiceWorker: UpdateServiceWorker | null;
  applyUpdate: () => Promise<void>;
  setActiveWalkthroughKey: (activeWalkthroughKey: WalkthroughKey | null) => void;
  setNeedRefresh: (needRefresh: boolean) => void;
  setUpdateServiceWorker: (updateServiceWorker: UpdateServiceWorker | null) => void;
};

export const useServiceWorkerUpdateStore = createWithEqualityFn<ServiceWorkerUpdateStore>()((set, get) => ({
  activeWalkthroughKey: null,
  isUpdating: false,
  needRefresh: false,
  updateServiceWorker: null,
  applyUpdate: async () => {
    const { isUpdating, updateServiceWorker } = get();
    if (isUpdating || !updateServiceWorker) return;

    set({ isUpdating: true });
    try {
      await updateServiceWorker(true);
      set({ needRefresh: false });
    } catch (error) {
      console.error('Failed to apply service worker update.', error);
    } finally {
      set({ isUpdating: false });
    }
  },
  setActiveWalkthroughKey: (activeWalkthroughKey) => set({ activeWalkthroughKey }),
  setNeedRefresh: (needRefresh) => set({ needRefresh }),
  setUpdateServiceWorker: (updateServiceWorker) => set({ updateServiceWorker }),
}));
